import { Badge } from "components/Theme/badge";
import { type Status, statusEnum } from "kubb";
import type React from "react";

export default function DeletedLabel(props: {
  object: { status: Status };
}): React.ReactElement {
  /* TODO: small size badge */
  if (props.object.status === statusEnum.DELETED) {
    return (
      <Badge color={"danger"} className={"mx-1"}>
        Deleted
      </Badge>
    );
  } else {
    return <></>;
  }
}
